import { render } from "./MyCover.vue?vue&type=template&id=94ae729c&scoped=true"
import script from "./MyCover.vue?vue&type=script&lang=js"
export * from "./MyCover.vue?vue&type=script&lang=js"

import "./MyCover.vue?vue&type=style&index=0&id=94ae729c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ae729c"]])

export default __exports__